import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';
import { ServiceResponse } from '@sdbn/common';
import { TransportOptionConfiguration } from './transport-options.model';

@Injectable({
    providedIn: 'root'
})

export class TransportOptionsAdministrationService {

    constructor(private appServerAPI: AppServerAPI) { }

    public loadOptionConfiguration(): Observable<TransportOptionConfiguration> {
        return this.appServerAPI.execute<TransportOptionConfiguration>('/client/admin/transportoptions', {});
    }

    public saveTransportOptions(configuration: TransportOptionConfiguration): Observable<ServiceResponse> {
        return this.appServerAPI.execute<ServiceResponse>('/client/admin/transportoptions/save', configuration);
    }
}
